import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/error-boundary/ErrorBoundary";
import { WorkspaceProvider } from "./context/WorkspaceContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary boundaryName="Root">
    <WorkspaceProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </WorkspaceProvider>
  </ErrorBoundary>
);
